$(() => {

    $('body .parking-tabs').each((index, tab) => {
        const $tabItems = $(tab).find('.parking-tabs__menu-item');
        const $tabContentItems = $(tab).find('.parking-tabs__tab-content');
        const $tabContentList = $(tab).find('.parking-tabs__tab-wrapper');
        const $tabMenu = $(tab).find('.parking-tabs__menu');
        const $tabMenuItem = $(tab).find('.parking-tabs__menu-item');
        let swiper = undefined;
        let activeTab = 0;
        let timeout;

        const init = () => {
            $tabItems.each((index, item) => {

                if ($(item).hasClass('parking-tabs__menu-item_active')) {
                    activeTab = index;
                }
            });

            setItem(activeTab);
            getScrollMenu();
            windowResize();
        };

        const setHeight = function (index)  {
            const height = $tabContentItems.eq(index).innerHeight();

            $tabContentList.innerHeight(height);

            if($tabContentItems.eq(index).closest('.map-parking__map-modal').length) {
                $tabContentItems.eq(index).closest('.map-parking__map-modal').trigger('getHeight');
            }
        };

        const setItem = (index) => {
            $tabItems.removeClass('parking-tabs__menu-item_active');
            $tabContentItems.removeClass('parking-tabs__tab-content_active');
            $tabItems.eq(index).addClass('parking-tabs__menu-item_active');
            $tabContentItems.eq(index).addClass('parking-tabs__tab-content_active');
            setHeight(index);
        };

        const getScrollMenu = () => {
            let itemsWidth = 0;
            $tabMenuItem.each((index, item) => {

                const itemInnerWidth = $(item).find('.parking-tabs__menu-text').innerWidth();
                const itemWidth = $(item).innerWidth();
                itemsWidth += (index == $tabMenuItem.length - 1) ? itemInnerWidth : itemWidth;
            });

            if(itemsWidth > $tabMenu.innerWidth() && $(window).innerWidth() < 1023) {
                if(swiper) return false;

                swiper = new Swiper($tabMenu[0], {
                    slidesPerView: 'auto',
                    spaceBetween: 0,
                });

                $('body').on('changeTab', function(event, index) {
                    swiper.slideTo(index);
                });
            } else {
                if(!swiper) return false;
                swiper.destroy();
                swiper = undefined;
            }
        };

        const windowResize = () => {
            clearTimeout(timeout);

            timeout = setTimeout(() => {
                $(window).on('resize', () => {
                    getScrollMenu();
                    setHeight(activeTab);
                });
            }, 100);
        };

        init();

        $tabItems.on('click', function() {
            const $tab =  $(this);
            const index = $tab.index();

            if(activeTab != index) {
                activeTab = index;
                setItem(activeTab, $(this));
                setHeight(index);

                $tab.trigger('changeTab', [index]);
            }
        });
    });
});



// WEBPACK FOOTER //
// ./src/scripts/components/parking-tabs/index.js